module.exports = __webpack_public_path__ + "static/media/tv.d78bd31e.svg";